// extracted by mini-css-extract-plugin
export default {"discountChip":"eyhyGPpXhgWiKJltevhg"};